import React, { useState } from "react";

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(circle at 20% 0%, rgba(47,123,255,0.18), transparent 30%), radial-gradient(circle at 80% 10%, rgba(94,92,230,0.14), transparent 28%), linear-gradient(180deg, #050816 0%, #09101F 42%, #0C1423 100%)",
  color: "#F8FAFC",
  padding: "40px 20px 80px",
};

const containerStyle = {
  maxWidth: "760px",
  margin: "0 auto",
};

const cardStyle = {
  background: "rgba(13, 17, 28, 0.72)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "30px",
  boxShadow:
    "0 18px 60px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255,255,255,0.06)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  padding: "32px",
};

const titleStyle = {
  fontSize: "clamp(32px, 5vw, 48px)",
  lineHeight: 1.05,
  fontWeight: 800,
  letterSpacing: "-0.04em",
  margin: "0 0 16px",
};

const paragraphStyle = {
  fontSize: "17px",
  lineHeight: 1.7,
  color: "rgba(226,232,240,0.88)",
  margin: "0 0 28px",
};

const infoCardStyle = {
  marginBottom: "28px",
  borderRadius: "22px",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  padding: "22px",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)",
};

const infoTitleStyle = {
  margin: "0 0 14px",
  fontSize: "16px",
  fontWeight: 700,
  color: "#F8FAFC",
  letterSpacing: "-0.01em",
};

const infoTextStyle = {
  margin: "0 0 12px",
  fontSize: "14px",
  lineHeight: 1.75,
  color: "rgba(226,232,240,0.82)",
};

const infoListStyle = {
  margin: 0,
  paddingLeft: "18px",
  display: "grid",
  gap: "10px",
  color: "rgba(226,232,240,0.82)",
  fontSize: "14px",
  lineHeight: 1.7,
};

const fieldGroupStyle = {
  display: "grid",
  gap: "18px",
};

const labelStyle = {
  display: "grid",
  gap: "8px",
  fontSize: "14px",
  fontWeight: 600,
  color: "#E2E8F0",
};

const inputStyle = {
  width: "100%",
  padding: "15px 16px",
  borderRadius: "16px",
  border: "1px solid rgba(255,255,255,0.10)",
  background: "rgba(255,255,255,0.04)",
  color: "#F8FAFC",
  fontSize: "16px",
  outline: "none",
};

const buttonStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "10px",
  padding: "16px 24px",
  borderRadius: "999px",
  background: "linear-gradient(135deg, #2F7BFF 0%, #5E5CE6 100%)",
  color: "#FFFFFF",
  textDecoration: "none",
  fontWeight: 700,
  fontSize: "15px",
  letterSpacing: "-0.01em",
  boxShadow: "0 12px 30px rgba(47, 123, 255, 0.25)",
  border: "1px solid rgba(255,255,255,0.08)",
  cursor: "pointer",
  marginTop: "22px",
};

const backLinkStyle = {
  display: "inline-flex",
  alignItems: "center",
  color: "#C7D2FE",
  textDecoration: "none",
  marginBottom: "22px",
  fontSize: "15px",
};

export default function PaymentPage() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !formData.fullName.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim()
    ) {
      alert("Lütfen ad soyad, e-posta ve telefon numarası alanlarını doldurun.");
      return;
    }

    try {
      setIsSubmitting(true);

      const stripeBackendUrl = import.meta.env.VITE_STRIPE_BACKEND_URL;

      if (!stripeBackendUrl) {
        throw new Error("VITE_STRIPE_BACKEND_URL tanımlı değil.");
      }

      const response = await fetch(
        `${stripeBackendUrl}/create-checkout-session`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fullName: formData.fullName.trim(),
            email: formData.email.trim(),
            phone: formData.phone.trim(),
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Checkout session oluşturulamadı.");
      }

      if (!data.url) {
        throw new Error("Stripe checkout URL dönmedi.");
      }

      window.location.href = data.url;
    } catch (error) {
      console.error("Payment checkout error:", error);
      alert("Ödeme sayfası açılamadı. Lütfen tekrar deneyin.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <a href="/gc-about" style={backLinkStyle}>
          ← Geri dön
        </a>

        <div style={cardStyle}>
          <h1 style={titleStyle}>Fotoğraf analizi için ödeme</h1>
          <p style={paragraphStyle}>
            Lütfen ödemenizi başlatmadan önce temel bilgilerinizi girin. Ödeme
            tamamlandıktan sonra fotoğraflarınızı yükleyebileceğiniz sayfaya
            yönlendirileceksiniz.
          </p>

          <div style={infoCardStyle}>
            <h2 style={infoTitleStyle}>Fotoğraf yükleme bilgilendirmesi</h2>
            <p style={infoTextStyle}>
              Analizin daha doğru yapılabilmesi için yüklenecek fotoğrafların
              belirli kalite standartlarına uygun olması gerekir.
            </p>
            <ul style={infoListStyle}>
              <li>
                Fotoğraflar, saç ekimi operasyonundan hemen sonra çekilmiş
                olmalıdır.
              </li>
              <li>
                Görseller iyi ışıklandırılmış, net ve mümkün olduğunca gölgesiz
                olmalıdır.
              </li>
              <li>
                Ekim yapılan alan açık şekilde görünmeli, fotoğraf bulanık veya
                çok uzaktan çekilmiş olmamalıdır.
              </li>
              <li>
                Analiz için yalnızca standart görsel formatları uygun kabul
                edilmektedir: JPG, JPEG, PNG, WEBP.
              </li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>
                Ad Soyad
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Ad Soyad"
                  style={inputStyle}
                />
              </label>

              <label style={labelStyle}>
                E-posta
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="ornek@mail.com"
                  style={inputStyle}
                />
              </label>

              <label style={labelStyle}>
                Telefon Numarası
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+90 5xx xxx xx xx"
                  style={inputStyle}
                />
              </label>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                ...buttonStyle,
                opacity: isSubmitting ? 0.7 : 1,
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              {isSubmitting
                ? "Ödeme Sayfası Açılıyor..."
                : "Stripe ile Ödeme Yap"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}